/* Consistent nl-NL formatters.
   Gebruik overal in de app om komma/punt- en enkelvoud/meervoud-fouten te vermijden. */

export function formatCurrency(amount, opts = {}) {
  const { withSymbol = true, minimumFractionDigits = 2 } = opts;
  const n = Number(amount || 0);
  const nr = n.toLocaleString('nl-NL', {
    minimumFractionDigits,
    maximumFractionDigits: 2,
  });
  return withSymbol ? `€ ${nr}` : nr;
}

export function formatDate(iso, opts = {}) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString('nl-NL', opts);
  } catch { return "—"; }
}

export function formatDateTime(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString('nl-NL', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  } catch { return "—"; }
}

/* Nederlandse enkel-/meervoud voor een woord + telwoord.
   Voorbeeld: pluralNL(0, "factuur", "facturen") → "geen facturen"
              pluralNL(1, "factuur", "facturen") → "1 factuur"
              pluralNL(3, "factuur", "facturen") → "3 facturen"
*/
export function pluralNL(count, singular, plural) {
  const n = Number(count || 0);
  if (n === 0) return `geen ${plural}`;
  if (n === 1) return `1 ${singular}`;
  return `${n} ${plural}`;
}

/* Datum-helpers in LOKALE tijdzone (Europe/Amsterdam voor deze app).
   toISOString() geeft UTC en veroorzaakt off-by-one bij middernacht.
   Gebruik overal deze helpers in plaats van new Date().toISOString().slice(0,10). */
export function localISO(dt) {
  const d = dt instanceof Date ? dt : new Date(dt);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function localToday() {
  return localISO(new Date());
}

/* Snap willekeurige datum naar de MAANDAG van die week.
   Werkt in lokale tijd zodat het rondom middernacht correct blijft. */
export function localWeekMonday(d) {
  const dt = new Date((d instanceof Date ? localISO(d) : d) + "T00:00:00");
  const day = dt.getDay(); // 0=zondag, 1=maandag, ..., 6=zaterdag
  const diff = day === 0 ? -6 : 1 - day;
  dt.setDate(dt.getDate() + diff);
  return localISO(dt);
}
